import React from 'react';
import {Popup} from 'components';
import {noop, over} from 'helpers';
import css from './list.module.scss';

export function List({children, setValue, onSelect = noop}) {
  const onClick = over(setValue, onSelect);
  return (
    <Popup.Menu className={css.list} onClick={noop}>
      { children.map(item =>
        <Popup.Menu.Item key={item.props.children} onClick={() => onClick(item.props.children)}>
          { item.props.children }
        </Popup.Menu.Item>
      ) }
    </Popup.Menu>
  );
}
